// src/app/redux/actions/niveauSkillActions.js

export const FETCH_NIVEAU_SKILLS_REQUEST = "FETCH_NIVEAU_SKILLS_REQUEST";
export const FETCH_NIVEAU_SKILLS_SUCCESS = "FETCH_NIVEAU_SKILLS_SUCCESS";
export const FETCH_NIVEAU_SKILLS_FAIL    = "FETCH_NIVEAU_SKILLS_FAIL";

export const CREATE_NIVEAU_SKILL_REQUEST = "CREATE_NIVEAU_SKILL_REQUEST";
export const CREATE_NIVEAU_SKILL_SUCCESS = "CREATE_NIVEAU_SKILL_SUCCESS";
export const CREATE_NIVEAU_SKILL_FAIL    = "CREATE_NIVEAU_SKILL_FAIL";

export const UPDATE_NIVEAU_SKILL_REQUEST = "UPDATE_NIVEAU_SKILL_REQUEST";
export const UPDATE_NIVEAU_SKILL_SUCCESS = "UPDATE_NIVEAU_SKILL_SUCCESS";
export const UPDATE_NIVEAU_SKILL_FAIL    = "UPDATE_NIVEAU_SKILL_FAIL";

export const DELETE_NIVEAU_SKILL_REQUEST = "DELETE_NIVEAU_SKILL_REQUEST";
export const DELETE_NIVEAU_SKILL_SUCCESS = "DELETE_NIVEAU_SKILL_SUCCESS";
export const DELETE_NIVEAU_SKILL_FAIL    = "DELETE_NIVEAU_SKILL_FAIL";

export const SET_NIVEAU_SKILL_LOADING   = "SET_NIVEAU_SKILL_LOADING";
export const CLEAR_NIVEAU_SKILL_ERROR   = "CLEAR_NIVEAU_SKILL_ERROR";

// Action creators
export const fetchNiveauSkillsRequest = () => ({ type: FETCH_NIVEAU_SKILLS_REQUEST });
export const fetchNiveauSkillsSuccess = (data) => ({ type: FETCH_NIVEAU_SKILLS_SUCCESS, payload: data });
export const fetchNiveauSkillsFail    = (error) => ({ type: FETCH_NIVEAU_SKILLS_FAIL, error });

export const createNiveauSkillRequest = (payload) => ({ type: CREATE_NIVEAU_SKILL_REQUEST, payload });
export const createNiveauSkillSuccess = (data)    => ({ type: CREATE_NIVEAU_SKILL_SUCCESS, payload: data });
export const createNiveauSkillFail    = (error)   => ({ type: CREATE_NIVEAU_SKILL_FAIL, error });

export const updateNiveauSkillRequest = (id, payload) => ({ type: UPDATE_NIVEAU_SKILL_REQUEST, payload: { id, payload } });
export const updateNiveauSkillSuccess = (data)        => ({ type: UPDATE_NIVEAU_SKILL_SUCCESS, payload: data });
export const updateNiveauSkillFail    = (error)       => ({ type: UPDATE_NIVEAU_SKILL_FAIL, error });

export const deleteNiveauSkillRequest = (id)  => ({ type: DELETE_NIVEAU_SKILL_REQUEST, payload: { id } });
export const deleteNiveauSkillSuccess = (id)  => ({ type: DELETE_NIVEAU_SKILL_SUCCESS, payload: { id } });
export const deleteNiveauSkillFail    = (error) => ({ type: DELETE_NIVEAU_SKILL_FAIL, error });

export const setNiveauSkillLoading  = (loading) => ({ type: SET_NIVEAU_SKILL_LOADING, payload: loading });
export const clearNiveauSkillError  = ()        => ({ type: CLEAR_NIVEAU_SKILL_ERROR });